import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";

import {durationToUnits, formatDuration} from "utils";
import {Route} from "v2/api/Records";
import DestinationSidebarLink from "v2/components/DestinationSidebarLink";
import RouteTargets from "v2/components/RouteTargets";
import styles from "v2/styles";

const DestinationsSidebar = (props) => {
  const {onDestinationMouseEnter, onDestinationMouseLeave, route, style} = props;

  const counter = route.destinations.size;
  const destinationsLabel = counter === 1 ?
    "One destination" :
    `${counter} destinations`;

  const totalTime = route
    .destinations
    .reduce(
      (result, item) => moment.duration(result + item.duration),
      moment.duration()
    );
  const drivingTime = route
    .destinations
    .reduce(
      (result, item, idx) => {
        const duration = moment.duration(item.estStartTime.diff(
          route.destinations.get(idx - 1).estEndTime,
          "milliseconds"));

        // Ignore negative durations
        if (duration < moment.duration()) {
          return result;
        }

        return moment.duration(result + duration);
      },
      moment.duration()
    );

  let routeTargets;
  let balanceStatus = "";
  if (moment(route.date).isAfter(moment(), "day")) {
    if (route.balance > 0) {
      balanceStatus = "text-danger";
    } else if (route.balance < 0) {
      balanceStatus = "text-warning";
    }
    routeTargets = <RouteTargets route={route} />;
  }

  return (
    <div className="small" style={style}>
      <div className="erg-padding-15" style={{borderBottom: styles.BORDER}}>
        <div
          className={`clearfix ${balanceStatus}`}>
          <strong className="erg-block pull-left">
            {destinationsLabel}
          </strong>
          <span className="erg-block pull-right">
            <i className="fa fa-clock-o" /> {formatDuration(totalTime, false)}
            <span className="erg-margin-left-10">
              <i className="fa fa-car" /> {durationToUnits(drivingTime, "minutes")} min
            </span>
          </span>
        </div>
        {routeTargets}
      </div>
      {route.destinations.map(item => (
        <DestinationSidebarLink
          data={item}
          key={`destination-${item.id}`}
          onMouseEnter={onDestinationMouseEnter && onDestinationMouseEnter.bind(null, item.id)}
          onMouseLeave={onDestinationMouseLeave && onDestinationMouseLeave.bind(null, item.id)} />
      ))}
    </div>
  );
};

DestinationsSidebar.defaultProps = {
  style: {},
};
DestinationsSidebar.propTypes = {
  onDestinationMouseEnter: PropTypes.func,
  onDestinationMouseLeave: PropTypes.func,
  route: PropTypes.instanceOf(Route).isRequired,
  style: PropTypes.object,
};

export default DestinationsSidebar;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationsSidebar.js
 **/